import { useAuth } from '../../../modules/auth';
import { useState, useEffect } from 'react';
import { useAppSelector } from '../../../../redux/hooks';
import ModalSwal from '../../../modules/permisoDenegado/Modalswal';
import Connectivity from '../../../modules/custom/Graphics/components/ConnectivityTab';
import LatencyTablePerfor from '../../..//modules/custom/Graphics/components/Latency_Performance';
import { Routes, Route, NavLink, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Spinner } from 'react-bootstrap'; // Importar Spinner para mostrar mientras carga

const MonitoringModule: React.FC = () => {
  const ListaPermisosTenant = useAppSelector(state => state.ListPermissionSlice.Permissions);
  const { currentUser } = useAuth();
  const [flag, setflag] = useState<number>();
  const [num, setnum] = useState<number>();
  const location = useLocation();
  const [loading, setLoading] = useState(true); // Estado de loading
  const navigate = useNavigate();

  useEffect(() => {
    if (currentUser?.ListPermiso?.includes('Ctx.Monitoring.View')) {
      setflag(1);
      setnum(1);
    } else if (currentUser?.ListPermiso?.includes('Ctx.Monitoring.View')) {
      setflag(2);
    } else if (currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.BGP')) {
      setflag(3);
    } else if (currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.MPLS')) {
      setflag(4);
    } else if (!ListaPermisosTenant.includes('Ctx.Monitoring.View')) {
      setflag(1);
    }
  }, [currentUser, ListaPermisosTenant]);

  // Validación de permisos y redirección con estado de carga
  useEffect(() => {
    const delay = setTimeout(() => {
      if (ListaPermisosTenant.length > 0) {
        setLoading(false); // Detener el estado de loading cuando los permisos estén cargados

        if (!ListaPermisosTenant.includes('Ctx.Monitoring.View')) {
          // Si no tiene permisos de Monitoring, validamos si tiene Home.Status
          if (ListaPermisosTenant.includes('Home.Status')) {
            navigate('/dashboard/status');
          } else {
            // Si no tiene Home.Status, redirigimos a cloudConnectivity
            navigate('/cloudConnectivity');
          }
        }
      }
    }, 1000); // Retraso de 1 segundo para simular la validación de permisos

    // Limpiar el timeout si el componente se desmonta
    return () => clearTimeout(delay);
  }, [ListaPermisosTenant, navigate]);

  // Mostrar spinner mientras se validan los permisos
  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
        <Spinner animation="border" role="status" variant="primary">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
        <div className="text-marino" style={{ marginTop: '20px', fontSize: '18px', color: '#007bff' }}>We are validating your permissions...</div>
      </div>
    );
  }

  return (
    <div className='card mb-5 mb-xl-5'>
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='f-titulo text-marino fs-md'>Monitoring Module</span>
        </h3>
      </div>
      <ul style={{ marginLeft: '25px', marginRight: '25px' }} className="nav nav-tabs nav-line-tabs mb-5 fs-6">
        {(currentUser?.ListPermiso?.includes('Ctx.Monitoring.View') || !ListaPermisosTenant.includes('Ctx.Monitoring.View')) && (
          <li className="nav-item">
            <NavLink
              className={`nav-link f-parrafo fs-p ${location.pathname.includes('status') ? 'active' : ''}`}
              to="status"
              onClick={() => (setflag(1), setnum(1))}
            >
              Status
            </NavLink>
          </li>
        )}
        {(currentUser?.ListPermiso?.includes('Ctx.Monitoring.View') || !ListaPermisosTenant.includes('Ctx.Monitoring.View')) && (
          <li className="nav-item f-parrafo fs-p">
            <NavLink
              className={`nav-link ${location.pathname.includes('instances') ? 'active' : ''}`}
              to="instances"
              onClick={() => (setflag(2), setnum(2))}
            >
              Instances
            </NavLink>
          </li>
        )}
      </ul>
      <div style={{ marginLeft: '25px', marginRight: '25px' }} className="tab-content" id="myTabContent">
        <Routes>
          {(currentUser?.ListPermiso?.includes('Ctx.Monitoring.View') || !ListaPermisosTenant.includes('Ctx.Monitoring.View')) && (
            <Route path="status" element={
              <div className="tab-pane fade active show" style={{ height: '65vh' }} id="kt_tab_pane_1" role="tabpanel">
                <Connectivity tab={num}></Connectivity>
              </div>
            } />
          )}
          {(currentUser?.ListPermiso?.includes('Ctx.Monitoring.View') || !ListaPermisosTenant.includes('Ctx.Monitoring.View')) && (
            <Route path="instances" element={
              <div className="tab-pane fade active show" id="kt_tab_pane_2" role="tabpanel">
                <LatencyTablePerfor tab={num}></LatencyTablePerfor>
                <br />
                <br />
              </div>
            } />
          )}
          {/* Default route */}
          {(currentUser?.ListPermiso?.includes('Ctx.Monitoring.View') || !ListaPermisosTenant.includes('Ctx.Monitoring.View')) ? (
            <Route path="*" element={<Navigate to="status" />} />
          ) : (
            <Route path="*" element={<Navigate to="/accounts/billing" />} />
          )}
        </Routes>
      </div>
    </div>
  );
}

export { MonitoringModule };
